import Swal from "sweetalert2";
import axios from "../../axios";
import { ADD_BRAND, DELETE_BRAND, GET_BRANDS, UPDATE_BRAND } from "../types";
import { setAlert } from "./alert";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getBrands = () => async (dispatch) => {
  try {
    const res = await axios.get("brand/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_BRANDS, payload: res.data.data });
    }
  } catch (err) {
    console.log("err :", err);
    // dispatch(setAlert(err.message, "danger"));
    // // Use the global error message function
    // const errorMessage = getErrorMessage(err.response?.data);

    // Swal.fire({
    //     title: 'Error!',
    //     text: errorMessage,
    //     icon: 'error',
    // });
  }
};
export const addBrand = (data, isFormData = false) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    };

    const res = await axios.post("brand/add", data, config);

    if (res.data.code === 1) {
      dispatch({ type: ADD_BRAND, payload: res.data.data });
      Swal.fire({ title: "Success!", text: res.data.message, icon: "success" });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({ title: "Warning!", text: res.data.message, icon: "warning" });
    }
  } catch (err) {
    const errMsg = err?.response?.data?.message || err.message || "Something went wrong";
    dispatch(setAlert(errMsg, "danger"));
    Swal.fire({ title: "Error!", text: errMsg, icon: "error" });
  }
};

export const updateBrand = (data, isFormData = false) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    };

    const res = await axios.post("brand/update", data, config);

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_BRAND, payload: res.data.data });
      Swal.fire({ title: "Success!", text: res.data.message, icon: "success" });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({ title: "Warning!", text: res.data.message, icon: "warning" });
    }
  } catch (err) {
    const errMsg = err?.response?.data?.message || err.message || "Something went wrong";
    dispatch(setAlert(errMsg, "danger"));
    Swal.fire({ title: "Error!", text: errMsg, icon: "error" });
  }
};

export const updateBrandStatus = (id, status) => async (dispatch) => {
  try {
    // const updatedFormData = { ...formData, id: formData._id };
    // console.log("formdata updateCustomerStatus:", id, status);

    const res = await axios.post(
      "brand/update",
      { id, status },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_BRAND, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // Use the global error message function
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: 'Error!',
      text: errorMessage,
      icon: 'error',
    });
  }
};

// export const updateBrand = (formData) => async (dispatch) => {
//   try {
//     console.log('Updating brand with data:', formData); // Log the data
//     const updatedFormData = new FormData();
//     updatedFormData.append('id', formData._id);
//     if (formData.name) updatedFormData.append('name', formData.name);
//     if (formData.image && formData.image.length > 0) {
//       updatedFormData.append('image', formData.image[0].originFileObj);
//     }

//     const config = {
//       headers: {
//         'Content-Type': 'multipart/form-data'
//       }
//     };

//     const res = await axios.post("brand/update", updatedFormData, config);
//     console.log('Update response:', res.data); // Log the response

//     if (res.data.code === 1) {
//       dispatch({ type: UPDATE_BRAND, payload: res.data.data });
//       Swal.fire({
//         title: 'Success!',
//         text: res.data.message,
//         icon: 'success',
//       });
//       dispatch(setAlert(res.data.message, "success"));
//     } else {
//       dispatch(setAlert(res.data.message, "warning"));
//       Swal.fire({
//         title: 'Warning!',
//         text: res.data.message,
//         icon: 'warning',
//       });
//     }
//   } catch (err) {
//     dispatch(setAlert(err.message, "danger"));
//   }
// };

export const deleteBrand = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`brand/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_BRAND, payload: { id } });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
    if (res.data.code === 0) {
      Swal.fire({
        title: "Error!",
        text: res.data.message || "An unexpected error occurred",
        icon: "error",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // Use the global error message function
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
